/** @jsx jsx */
import { ReactNode, FunctionComponent } from 'react';

import { Colors } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Divider from '../Divider';
import NavLink, { Props as NavLinkProps } from './NavLink';
import Section, { Props as SectionProps } from './Section';

const Styles = {
  root: css`
    border-right: 1px solid ${Colors.GrayWarm4};
    display: flex;
    flex-direction: column;
    width: 340px;
  `,
  items: css`
    flex-grow: 1;
    overflow: auto;
  `,
};

type Props = {
  children?: ReactNode;
  /** Top header of the sidebar. Renders a divider to separate it from items. */
  summary: ReactNode;
  /** The actual nav items of the sidebar */
  items: ReactNode;
};

type ICompoundIntegrationSidebar = FunctionComponent<Props> & {
  Divider: FunctionComponent;
  NavLink: FunctionComponent<NavLinkProps>;
  Section: FunctionComponent<SectionProps>;
};

/**
 * Renders a navigation sidebar with sectioned header.
 * This is a compound component that also includes NavLink.
 *
 * @param props
 */
const IntegrationSidebar: ICompoundIntegrationSidebar = ({
  children,
  summary,
  items,
}) => {
  return (
    <nav css={Styles.root}>
      <header>{summary}</header>
      <Divider />
      <main css={Styles.items}>{items || children}</main>
    </nav>
  );
};

IntegrationSidebar.Divider = Divider;
IntegrationSidebar.NavLink = NavLink;
IntegrationSidebar.Section = Section;

export default IntegrationSidebar;
